module.exports = __webpack_public_path__ + "img/rightcalf-ecto-mesomorph-male.a2d0d04b.svg";